import React from 'react'
import hr from "../../../images/speakers/presentation.webp"
import speaker from "../../../images/students/speaker.webp"
import chat from "../../../images/students/chat.webp"
import result from "../../../images/speakers/result.webp"



export default function WhatKnow() {
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] relative z-0 w-full  overflow-hidden text-center'>
            <img src={hr} alt='banner' loading='lazy' className='mx-auto object-cover w-[90px] md:w-[135px]' />
            <h5 className='text-[#000000] font-medium text-[22px] md:text-[30px]'>What you know is <span className='font-bold'>UNKNOWN</span> to millions of students.</h5>
            <p className='mt-[10px] md:mt-[20px] text-[#4A5565] font-medium text-[18px] md:text-[28px]'>That alone makes you powerful.</p>
            <div className='mt-[20px] md:mt-[50px] flex gap-[22px] flex-wrap justify-center items-center text-[#1E2939] text-[18px] md:text-[24px] font-semibold'>
                <div className='w-full md:w-[330px] p-[15px] md:py-[30px] border-[1px] border-[#E9EAEB] rounded-[12px] md:rounded-[18px] flex flex-col justify-center items-center'>
                    <img src={speaker} alt='speaker' loading='lazy' className='mx-auto w-[100px] md:w-[130px]'/>
                    <p className='mt-[10px] md:mt-[18px]'>You Speak</p>
                </div>
                <div className='w-full md:w-[330px] p-[15px] md:py-[30px] border-[1px] border-[#E9EAEB] rounded-[12px] md:rounded-[18px] flex flex-col justify-center items-center'>
                    <img src={chat} alt='discussion' loading='lazy' className='mx-auto w-[100px] md:w-[130px]'/>
                    <p className='mt-[10px] md:mt-[18px]'>We Guide</p>
                </div>
                <div className='w-full md:w-[330px] p-[15px] md:py-[30px] border-[1px] border-[#E9EAEB] rounded-[12px] md:rounded-[18px] flex flex-col justify-center items-center'>
                    <img src={result} alt='result' loading='lazy' className='mx-auto w-[100px] md:w-[130px]'/>
                    <p className='mt-[10px] md:mt-[18px]'>Students Transform</p>
                </div>
            </div>
        </div>
    )
}
